var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9758 11.845L22.987 17.2342C22.9963 21.7251 21.2036 23.5252 16.7127 23.5345L11.3235 23.5456C6.83259 23.5549 5.03249 21.7623 5.0232 17.2713L5.01205 11.8822",
    stroke: "url(#paint0_linear_1432_37225)",
    strokeWidth: 1.28313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4668 22.6219C8.6644 20.2866 11.0626 18.4453 13.9817 18.4453C16.9008 18.4453 19.299 20.2866 19.4966 22.6219",
    stroke: "url(#paint1_linear_1432_37225)",
    strokeWidth: 1.28313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46702 22.6225C6.02394 21.9309 5 20.0717 5 16.6765V11.2873C5 6.79638 6.79638 5 11.2873 5H16.6765C21.1674 5 22.9638 6.79638 22.9638 11.2873V16.6765C22.9638 20.0717 21.9399 21.9309 19.4968 22.6225M13.9819 15.931C12.2035 15.931 10.7664 14.4849 10.7664 12.7065C10.7664 10.9281 12.2035 9.49096 13.9819 9.49096C15.7603 9.49096 17.1974 10.9281 17.1974 12.7065C17.1974 14.4849 15.7603 15.931 13.9819 15.931Z",
    stroke: "url(#paint2_linear_1432_37225)",
    strokeWidth: 1.28313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1976 12.7067C17.1976 14.4852 15.7605 15.9312 13.9821 15.9312C12.2037 15.9312 10.7666 14.4852 10.7666 12.7067C10.7666 10.9283 12.2037 9.49121 13.9821 9.49121C15.7605 9.49121 17.1976 10.9283 17.1976 12.7067Z",
    stroke: "url(#paint3_linear_1432_37225)",
    strokeWidth: 1.28313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1432_37225",
    x1: 14.0181,
    y1: 23.5401,
    x2: 13.9939,
    y2: 11.8636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1432_37225",
    x1: 13.9817,
    y1: 18.4453,
    x2: 13.9817,
    y2: 22.6219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1432_37225",
    x1: 13.9819,
    y1: 5,
    x2: 13.9819,
    y2: 22.6225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1432_37225",
    x1: 13.9821,
    y1: 9.49121,
    x2: 13.9821,
    y2: 15.9312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.29
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9abb9e8c85eb8a4380e7ed12cc4493a0.svg";
export { ForwardRef as ReactComponent };